export default function CarnetsSuiviConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('carnets.suivi');
}

CarnetsSuiviConfiguration.$inject = ['$translatePartialLoaderProvider'];
